import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

export const ZGatewayType = z.object({
  asset_type_id: z.string(),
  asset_type_name: z.string(),
  category_type_id: z.string(),
  category_type_name: z.string()
})

export const ZGatewayTypeData = z.array(ZGatewayType)

export const ZGatewayTypeApiResponse = z.object({
  http_status: z.any(),
  data: z.optional(ZGatewayTypeData),
  error: z.boolean(),
  error_message: z.optional(z.string())
})

export type GatewayType = z.infer<typeof ZGatewayType>

export function gatewayTypeService (
  categoryTypeId: string,
  onSuccess: (assetCategories: GatewayType[], httpStatus: number) => void,
  onFailure: (errorMessage: any, httpStatus: number) => void
): void {
  const url = `/assetrest/api/v2/udp/tiq/assets/devicetypes?categoryTypeId=${categoryTypeId}&assetGroup=${'gateway'}`

  interceptedAxios
    .get(url, { timeout: 15000 })
    .then((response) => {
      const responseData = response.data

      if (responseData.error === false) {
        if (responseData.data !== null && responseData.data !== undefined) {
          onSuccess(responseData.data, responseData.http_status)
        } else {
          onFailure(responseData.error, responseData.http_status)
        }
      } else {
        onFailure(responseData.error_message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        onFailure(
          error.response.data !== undefined || error.response.data !== null
            ? error.response.data.error_message
            : 'Network Error',
          error.response.status
        )
      } else {
        onFailure('Network Error', 404)
      }
    })
}
